import { formatInt } from '@/lib/format';

type Props = {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
};

export function Pagination({ page, pageSize, total, onChange }: Props) {
  const last = Math.max(1, Math.ceil(total / pageSize) || 1);
  return (
    <div className="mt-3 flex items-center gap-2 text-sm">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="rounded border px-2 py-1 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Prev
      </button>
      <span>
        Page {formatInt(page)} / {formatInt(last)} ({formatInt(total)} total)
      </span>
      <button
        type="button"
        disabled={page >= last}
        onClick={() => onChange(page + 1)}
        className="rounded border px-2 py-1 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Next
      </button>
    </div>
  );
}
